<template>
  <div v-if="payInfo">
    <div v-if="isSeparate" class="layer paymentLayer">
      <div class="inner">
        <p class="layerTitle">{{ locale.start_payment }}</p>
        <div class="btns">
          <button type="button" class="btn btnFull" @click.stop="paySubmit">{{ locale.do_payment }}</button>
        </div>
      </div>
    </div>
    <form name="payForm" id="payForm" method="post" target="_self" accept-charset="euc-kr">
      <!--CODclearfa  /   INIpayTest -->
      <input type="hidden" name="P_MID" :value="payInfo.P_MID" />
      <input type="hidden" name="P_UNAME" :value="payInfo.P_UNAME" />
      <input type="hidden" name="P_GOODS" :value="payInfo.P_GOODS" />
      <input type="hidden" name="P_AMT" :value="payInfo.P_AMT" />
      <input type="hidden" name="P_OID" :value="payInfo.P_OID" />
      <input type="hidden" name="P_NOTI" :value="payInfo.P_NOTI" />
      <input type="hidden" name="P_CHARSET" :value="payInfo.P_CHARSET" />
      <input type="hidden" name="P_NEXT_URL" :value="payInfo.P_NEXT_URL">
      <input type="hidden" name="P_INI_PAYMENT" :value="payInfo.P_INI_PAYMENT" />
    </form>
  </div>
</template>

<script>
import API from '@/common/api'

export default {
  name: 'InicisPayment',
  props: [
    'locale'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    }
  },
  mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      // 알림톡 등으로부터 접근한 기본루트
      if (!this.isSeparate) {
        setTimeout(() => {
          this.paySubmit()
        }, 100)
      } else {
        // QR코드로부터 접근한 독립 결제루트
      }
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false,
      apiUrl: API.BASE_URL
    }
  },
  methods: {
    paySubmit () {
      var actionUrl = 'https://mobile.inicis.com/smart/payment/'
      var f = document.payForm
      f.action = actionUrl
      f.submit()
      this.$emit('close')
      this.$destroy()
    },
    closePayment (e) {
      if (window.confirm(this.locale.confirm_cancel_payment)) {
        e.preventDefault()
        window.close()
        // this.payInfo = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentLayer {
  .inner {
    padding: 45px 30px;
    border-radius: 8px;
  }
  .layerTitle {
    text-align: center;
  }
  .btns {
    margin-top: 30px;
    .btn {
      padding-top: 1em;
      padding-bottom: 1em;
      border-radius: 8px;
    }
  }
}
</style>
